//import Patients from './screens/index.vue';
const Patients = () => import('./screens/index.vue')

import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const patientsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.PATIENT_VIEW,
    PERMISSIONS_KEYS.PATIENT_INSERT,
    PERMISSIONS_KEYS.PATIENT_EDIT,
  ])
) {
  patientsRoutes.push({
    path: '/regras-da-prescricao/pacientes',
    name: 'Cadastro / Consulta|Paciente',
    component: Patients,
    meta: {
      icon: 'fa-hospital',
      requiresAuth: true,
    },
  });
}

export { patientsRoutes };
